export const GATEWAY_URL = "https://system.adrp2go.de/backend";
//export const GATEWAY_URL = "http://localhost:1000"


export function generatePassword() {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; // Possible characters
  let password = '';
  
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length); // Random index from charset
    password += charset[randomIndex]; // Add random character to the password
  }

  return password;
}